<script>
  export let figure;
  export let addFigure;

  import { dictionary } from "../utils/stores.js";

  import { loadFile } from "../utils/revista.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let errorMsg = "";
  let divErrorCaption;

  let addFile = () => {
    loadFile("figuresInput", addFileReady);
  };

  let addFileReady = content => {
    figure.imagen = content;
    errorMsg = "";
    //articulo.figuras.push()
    //articulo.manuscript = content;
  };

  let add = () => {
    const error =
      figure.caption === "" || divErrorCaption.classList.contains("has-error");
    if (!error) {
      if (figure.imagen === "") {
        errorMsg = dict["errorSinImagen"];
      } else {
        addFigure();
      }
    }
  };
</script>

<style>
  div.center {
    display: flex;
    justify-content: center;
  }
</style>

<div id="newFigure" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{dict['nuevaFigura']}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="rd-form rd-mailform" id="newFigureForm">

          {#if errorMsg !== ''}
            <div class="alert alert-danger" role="alert">{errorMsg}</div>
          {/if}
          {#if figure.imagen !== ''}
            <img src={figure.imagen} alt="Imagen Figura" />
          {/if}
          <div class="form-group">
            <input
              id="figuresInput"
              type="file"
              class="form-control-file"
              accept=".jpg,.jpeg,.png"
              on:change={() => addFile()} />
          </div>
          <div class="form-wrap" bind:this={divErrorCaption}>
            <input
              class="form-input"
              id="add-title"
              type="text"
              name="title"
              placeholder={dict['titulo']}
              data-constraints="@Required"
              bind:value={figure.descripcion} />
          </div>
          <div class="form-wrap center">
            <button
              class="button button-sm button-primary"
              type="button"
              on:click={() => add()}>
              {dict['anadirFigura']}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
